import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
import {useNavigate} from 'react-router-dom';
import { IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableComponent from '../component/table';
import PartDetailsPage from './customer_component/partDetails';
import Button from '@mui/material/Button';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {error, success, warning} from '../component/message'
import request from '../utilities/api';
import AlertDialogSlide from '../component/confirmation_modal';




function PartPage({partSelection, columns: PropsColumn}){

    const [response, setResponse] = useState({})
    const [actionType, setActionType] = useState("")
    const [selectedPart, setselectedPart] = useState({})
    const [openSlide, setOpenSlide] = useState(false)
    const [slideMessage, setSlideMessage] = useState('')
    const [selectedPartDelete, setSelectedPartDelete] = useState({})

    const columns = [
        {
            name: 'S.NO',
            selector: (row, index) => index + 1,
        },
        {
            name: 'Part Unique ID',
            selector: row => row.part_unique_id,
        },
        {
            name: 'Part Name',
            selector: row => row.part_name,
        },
        {
            name: 'Quantity',
            selector: row => row.part_quantity,
        },
        {
            name: 'Price',
            selector: row => row.part_price,
        },
        {
            name: 'Action',
            selector: row => (
                <>
                    <IconButton onClick={() => {
                        setselectedPart(row)
                        setActionType('view')
                    }}>
                        <VisibilityIcon/>
                    </IconButton>
                    <IconButton onClick={() => {
                        setSlideMessage(`Are you sure want delete ${row.part_name}`)
                        setSelectedPartDelete(row)
                        toggleOpenSlide()
                    }}>
                        <DeleteOutlineIcon style={{color: 'rgba(255,0,0,0.5)', size: '10px'}}/>
                    </IconButton>
                </>
            )
        }
    ];

    const naviagate = useNavigate()

    useEffect(() => {
        get_parts()
    },[])

    const get_parts = (info = {}) => {
        const {page = 1, search} = info
        const payload = {
            method: 'get',
            url_key: 'parts',
            params: {
                limit: 10,
                page: page,
                search
            }
        }
        request(payload)
        .then(res => {
            setResponse(res.data.data)
        })
        .catch(err => {
            console.log(err, '--err')
        })
    }

    const toggleOpenSlide = () => {
        setOpenSlide(!openSlide)
    }

    const removePart = () => {
        const {_id} = selectedPartDelete
        request({
            method: 'delete',
            url_key: 'delete_part',
            params: {},
            _id
        }).then(res => {
            const api_response = res.data
            setOpenSlide(false)
            setSlideMessage('')
            setSelectedPartDelete({})
            get_parts()
            success(api_response.message)
        })
        .catch(err => {
            const api_response = err.response
            error(api_response.data.message)
        })
    }

    const addNewPart = (payload) => {
        const api_payload = {
            method: 'post',
            url_key: 'parts',
            params: payload
        }
        request(api_payload)
        .then(res => {
            const response = res.data
            get_parts()
            setActionType("")
            success(response.message)
        })
        .catch(err => {
            const api_response = err.response?.data
            error(api_response.message)
        })
    }

    const updatePart = (payload) => {
        const api_payload = {
            method: 'put',
            url_key: 'update_part',
            params: payload,
            _id: selectedPart._id
        }
        request(api_payload)
        .then(res => {
            const response = res.data
            get_parts()
            setActionType("")
            success(response.message)
        })
        .catch(err => {
            const api_response = err.response?.data
            error(api_response.message)
        })
    }

    const onSearchText = (payload) => {
        get_parts({search: payload})
    }

    const generateBodyComponent = () => {
        switch(actionType){
            case "add":
                return <PartDetailsPage actionType={actionType} setActionType={setActionType} addNewPart={addNewPart}/>
            case "view":
                return <PartDetailsPage actionType={actionType} setActionType={setActionType} selectedPart={selectedPart} updatePart={updatePart}/>
            default:
                return <TableComponent 
                details={response}
                columns={partSelection ? PropsColumn : columns} 
                tableData={response.docs} 
                setselectedPart={setselectedPart} 
                setActionType={setActionType} 
                getDetails={get_parts}
                expandable={false}
                />
        }
    }

    const addNewButtonSubmit = () => {
        setActionType("add")
    }

    return (
        <div className='app-module-container'>
            {(actionType != 'view' && actionType != 'add') && <div className='app-module-appbar'>
                <div className='app-module-appbar-title'>
                    {!partSelection &&<h1>{actionType == "view" ? "Part Details" : "Part List" }</h1>}
                </div>
                {(actionType != 'view' && actionType != 'add') && 
                    <div className='flex' style={{alignItems: 'center', justifyContent: 'center'}}>
                        <Input.Search
                            className={"search-input-box"}
                            placeholder="Search with part name / part unique  id"
                            allowClear={true}
                            onSearch={onSearchText}
                        />
                        {!partSelection && <Button variant="contained" className='login-button' style={{minWidth: '100px', marginLeft: 10}} onClick={() => addNewButtonSubmit()}>Add New</Button>}
                    </div>
                }
            </div>}
            <div className='app-module-body'>
                {
                    generateBodyComponent()
                }
            </div>
            <AlertDialogSlide open={openSlide} setOpen={toggleOpenSlide} message={slideMessage} onSubmit={removePart}/>
        </div>
    )
}

export default PartPage